import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import UpdateContactModal from "./UpdateContactModal";
import UpdateTravelDocs from "./UpdateTravelDocs";
import { useDispatch } from "react-redux";
import { isbookingValid } from "../../redux/booking-validation";

const GuestDetails = ({ guest_info, booking_id }) => {
  const [showContactModal, setShowContactModal] = useState(false);
  const [showTravelDocsModal, setShowTravelDocsModal] = useState(false);
  const dispatch = useDispatch();

  const fetchBookingValidation = () => {
    dispatch(
      isbookingValid({
        booking_id: booking_id,
        last_name: guest_info.last_name,
      })
    );
  };

  useEffect(() => {
    if (showContactModal || showTravelDocsModal) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    // Cleanup function
    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [showContactModal, showTravelDocsModal]);

  return (
    <div className="w-full flex-grow-1 mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
      <div className="font-bold uppercase text-xl px-6 py-4 bg-[#E0EBF3] text-mv-darkblue">
        {guest_info.first_name + " " + guest_info.last_name}
      </div>
      <div className="px-6 py-4">
        <div className="text-gray-700 flex gap-4 flex-wrap">
          <div className="mb-4 overflow-hidden">
            <h3 className="font-semibold text-mv-darkblue text-lg">
              Contact Information
            </h3>
            <p className="overflow-clip">{guest_info.email}</p>
            <p className="overflow-clip">{guest_info.phone}</p>
            <Link
              onClick={() => setShowContactModal(true)}
              to="#"
              className="text-blue-600 font-semibold hover:underline"
            >
              Edit
            </Link>
          </div>
          {/* <div className="mb-4">
            <h3 className="font-semibold text-mv-darkblue text-lg">
              Stateroom Number
            </h3>
            <p>{guest_info?.room_no}</p>
          </div> */}
          <div>
            <div className="flex gap-4 items-center">
              <h3 className="font-semibold text-nowrap text-mv-darkblue text-lg">
                Travel Documents
              </h3>
              <span
                className={`${
                  guest_info.document_details.document_id !== "" ||
                  (guest_info.document_details.document_type.toLowerCase() ===
                    "Birth Certificate".toLowerCase() &&
                    guest_info.document_details.document_name)
                    ? "bg-green-600"
                    : "bg-red-600"
                } text-white text-sm font-semibold mr-2 px-2.5 py-0.5 rounded`}
              >
                {guest_info.document_details.document_id !== ""
                  ? "Complete"
                  : "Incomplete"}
              </span>
            </div>
            <p>{guest_info.document_details.document_type}</p>
            <p>{guest_info.document_details.document_id}</p>
            <p>{guest_info.document_details.expiry_date}</p>
            <Link
              onClick={() => setShowTravelDocsModal(true)}
              href="to"
              className="text-blue-600 font-semibold hover:underline"
            >
              Edit
            </Link>
          </div>
        </div>
      </div>
      {showContactModal && (
        <div className="fixed overflow-scroll bg-mv-backdrop z-10 bg-opacity-80 left-0 right-0 top-0 bottom-0 m-auto">
          <UpdateContactModal
            fetchBookingValidation={fetchBookingValidation}
            guest_info={guest_info}
            setShowContactModal={setShowContactModal}
            guest_id={guest_info.id}
          />
        </div>
      )}
      {showTravelDocsModal && (
        <div className="fixed bg-mv-backdrop overflow-scroll z-10 bg-opacity-80 left-0 right-0 top-0 bottom-0 m-auto">
          <UpdateTravelDocs
            fetchBookingValidation={fetchBookingValidation}
            document_details={guest_info.document_details}
            guest_info={guest_info}
            setShowTravelDocsModal={setShowTravelDocsModal}
          />
        </div>
      )}
    </div>
  );
};

export default GuestDetails;
